module.exports = __webpack_public_path__ + "media/assets/images/conference_room_forms/classroom-form-969021bd9e608f3dea4be106505ffd63.gif";